/*global Modernizr, console, SlimSelect, practice_legal_issues, form_practices */
/*jslint browser:true */

(function() {
  'use strict';

  if ( typeof mapViewTrigger !== 'undefined' ) {

    // Toggle Map and List view for attorney search results
    let mapContainer = document.getElementById('mapContainer');
    let resultsGrid = document.getElementsByClassName('results-grid');
    let mapViewTrigger = document.getElementById('mapViewTrigger');
    let pagination = document.getElementsByClassName('pagination');
    let listViewTrigger = document.getElementById('listViewTrigger');
    let iconSwitchChildren = document.getElementById('iconSwitch').children;

    mapViewTrigger.addEventListener('click', (e) => {
      mapContainer.classList.add('map-view');
      e.target.classList.add('active');
      listViewTrigger.classList.remove('active');
      for(let i = 0; i < iconSwitchChildren.length; i++) {
        iconSwitchChildren[0].classList.add('switched');
        iconSwitchChildren[1].classList.remove('switched');
      }
      for(let i = 0; i < resultsGrid.length; i++) {
        resultsGrid[i].classList.add('map-view');
      }
      for(let i = 0; i < pagination.length; i++) {
        pagination[i].classList.add('map-active');
      }
    });

    listViewTrigger.addEventListener('click', (e) => {
      mapContainer.classList.remove('map-view');
      e.target.classList.add('active');
      mapViewTrigger.classList.remove('active');
      for(let i = 0; i < iconSwitchChildren.length; i++) {
        iconSwitchChildren[1].classList.add('switched');
        iconSwitchChildren[0].classList.remove('switched');
      }
      for(let i = 0; i < resultsGrid.length; i++) {
        resultsGrid[i].classList.remove('map-view');
      }
      for(let i = 0; i < pagination.length; i++) {
        pagination[i].classList.remove('map-active');
      }
    });
  }


  // open mobile menu
  const menuToggle = document.getElementById('menuToggle');
  const navigation = document.getElementById('navigation');
  const overlay = document.getElementById('overlay');
  menuToggle.addEventListener('click' , function(e) {
    menuToggle.classList.toggle('active');
    navigation.classList.toggle('on');
    overlay.classList.toggle('on');
  });


  // open mobile menu subnavs
  let hasSubNavs = document.querySelectorAll('.has-sub-nav');
  if(hasSubNavs) {
    hasSubNavs.forEach((hasSubNav) => {
      var timer;
      hasSubNav.querySelector('a[aria-haspopup]').addEventListener('click', (e) => {
        e.preventDefault();
        hasSubNav.classList.toggle('open');
      });

      hasSubNav.querySelector('ul').addEventListener('focusin', function(event){
        if (timer) {
          clearTimeout(timer);
          timer = null;
        }
    	});

      hasSubNav.querySelector('ul').addEventListener('focusout', function(event){
    		timer = setTimeout(function(event){
    			document.querySelector(".has-sub-nav.open").classList.remove('open');
    		}, 20);
    	});
    });
  }


  if ( typeof compareTrigger !== 'undefined' ) {
    // toggle comparison bar
    const comparisonBar = document.getElementById('comparison-bar');
    const compareTrigger = document.getElementById('compareTrigger');
    compareTrigger.addEventListener('click' , function(e) {
      comparisonBar.classList.toggle('open');
    });
  }


  // advanced search trigger
  let advancedSearchTrigger = document.getElementById('advancedSearchTrigger');
  if(advancedSearchTrigger) {
    let searchForm = document.querySelector('.attorney-search-form');
    let advancedSearch = searchForm.querySelector('.advanced-search');
    advancedSearchTrigger.addEventListener('click' , function(e){
      advancedSearchTrigger.classList.toggle('search-open');
      searchForm.classList.toggle('show-advanced');

      if (advancedSearchTrigger.classList.contains('search-open')){
        advancedSearchTrigger.firstElementChild.innerHTML = 'Hide Advanced Search';
      } else {
        advancedSearchTrigger.firstElementChild.innerHTML = 'Advanced Search';
      }

    });
  }

  // attorney finder expanded trigger
  let attorneyFinderForm = document.querySelector('.attorney-finder-form');
  let attorneyFinderFormTrigger = document.querySelector('.triggerSearch');
  let results = document.querySelector('.results');
  let closeSearch = document.querySelector('.close-search');
  let resultsbarSticky = document.querySelector('#resultsBar');
  let searchResultsGrid = document.querySelector('.results-grid');
  if(attorneyFinderFormTrigger) {
    attorneyFinderFormTrigger.addEventListener('click' , function(e) {
      e.preventDefault();
      attorneyFinderForm.classList.toggle('hidden');
      results.classList.toggle('hidden');
      resultsbarSticky.classList.remove('sticky');
      resultsbarSticky.classList.toggle('notSticky');
      searchResultsGrid.classList.toggle('notSticky');
    });

    closeSearch.addEventListener('click' , function(e) {
      e.preventDefault();
      attorneyFinderForm.classList.toggle('hidden');
      results.classList.toggle('hidden');
      resultsbarSticky.classList.toggle('notSticky');
      searchResultsGrid.classList.toggle('notSticky');
    });
  }

  let attorneyFinderFiltersTrigger = document.querySelector('.show-filters');
  if(attorneyFinderFiltersTrigger) {
    attorneyFinderFiltersTrigger.addEventListener('click' , function(e) {

      results.classList.toggle('show-all');
      resultsbarSticky.classList.remove('sticky');
      resultsbarSticky.classList.toggle('notSticky');
      searchResultsGrid.classList.toggle('notSticky');
    });
  }

  if ( typeof resultsBar !== 'undefined' ) {

    // Make resultsBar and map sticky on scroll
    let mapContainer = document.getElementById('mapContainer');
    let resultsGrid = document.querySelector('.results-grid');
    let resultsBar = document.querySelector('#resultsBar');

    window.addEventListener('scroll', function() {
      let resultsBarPos = resultsBar.getBoundingClientRect().top;
      let scrollPos = window.scrollY;

      if (scrollPos >= resultsBarPos + 40) {
        resultsBar.classList.add('sticky');
        mapContainer.classList.add('stickyMap');
        for(let i = 0; i < resultsGrid.length; i++) {
          resultsGrid[i].classList.add('add-margin');
        }

      } else {
        resultsBar.classList.remove('sticky');
        mapContainer.classList.remove('stickyMap');
        for(let i = 0; i < resultsGrid.length; i++) {
          resultsGrid[i].classList.remove('add-margin');
        }
      }

    });

    // hightlight selected attorney card
    let highlights = resultsGrid.querySelectorAll('.highlight');
    const handleClick = (e) => {

      let selected = document.querySelector('.selected');

      if (selected) {
        selected.classList.remove('selected');
      }

      e.currentTarget.parentNode.parentNode.classList.add('selected');
    };

    highlights.forEach(hightlight => {
      hightlight.addEventListener('click', handleClick);
    });

  }

  // show all counties served for attorney profiles
  let gradientSlider = document.querySelector('.gradient-slider');
  if(gradientSlider) {
    let counties = document.querySelector('.counties ul');
    gradientSlider.addEventListener('click' , function(e){
      gradientSlider.classList.toggle('hidden');
      counties.classList.toggle('show');
    });
  }

  if (typeof practice_legal_issues !== 'undefined') {
    var area_of_practice = document.querySelector('select[name="area_of_practice"]');
    var legal_issues = document.querySelector('select[name="legal_issues"]');

    var check_area_of_practice = () => {
      legal_issues.innerHTML = '';

      if(area_of_practice.value === '') {
        legal_issues.disabled = true;
      } else {
        var legal_issue_options = practice_legal_issues[area_of_practice.value];

        // Set default
        let default_option = document.createElement('option');
        default_option.setAttribute('value', '');
        default_option.innerText = '';
        legal_issues.appendChild(default_option);

        for(const legal_issue_option in legal_issue_options) {
          let option = document.createElement('option');
          option.setAttribute('value', legal_issue_option);
          option.innerText = legal_issue_option;

          legal_issues.appendChild(option);
        }

        legal_issues.disabled = false;
      }
    };
    // check_area_of_practice();
    area_of_practice.addEventListener('change', check_area_of_practice);
  }

  if (typeof form_practices !== 'undefined') {
    var form_area_of_practice = document.querySelector('#form-legal-area');
    var form_legal_issues = document.querySelector('#form-legal-issue');

    var form_check_area_of_practice = () => {
      form_legal_issues.innerHTML = '';

      if(form_area_of_practice.value === '') {
        form_legal_issues.disabled = true;
      } else {
        var form_legal_issue_options = form_practices[form_area_of_practice.value];

        // Set default
        let default_option = document.createElement('option');
        default_option.setAttribute('value', '');
        default_option.innerText = '';
        form_legal_issues.appendChild(default_option);

        for(const legal_issue_option in form_legal_issue_options) {
          let option = document.createElement('option');
          option.setAttribute('value', legal_issue_option);
          option.innerText = legal_issue_option;

          form_legal_issues.appendChild(option);
        }

        form_legal_issues.disabled = false;
      }
    };
    form_check_area_of_practice();
    form_area_of_practice.addEventListener('change', form_check_area_of_practice);
  }

  var multi_selects = document.querySelectorAll('.multi-select');
  if(multi_selects) {
    multi_selects.forEach((multi_select) => {
      new SlimSelect({
          select: multi_select,
          searchText: 'Sorry couldnt find anything',
          placeholder: false,
          allowDeselectOption: true,
          closeOnSelect: false,
          showSearch: false,
      });
    });
  }

  var user_locations = document.querySelectorAll('.js-current-location');
  if(user_locations) {
    user_locations.forEach((user_location) => {
      user_location.addEventListener('click', (e) => {
        e.preventDefault();

        navigator.geolocation.getCurrentPosition(function(position) {
          document.getElementById('latitude').value = position.coords.latitude;
          document.getElementById('longitude').value = position.coords.longitude;

          document.querySelector('.attorney-search-form').submit();
        }, function(error) {
          alert('Unable to get your location. Please use adddress based search.');
        });
      });
    });
  }

  var results_search_options = document.querySelector('.results');
  if(results_search_options) {
    calculate_results_overflow(results_search_options);

    window.addEventListener('resize', () => {
      calculate_results_overflow(results_search_options);
    });
  }
  function calculate_results_overflow(results_bar) {
    var results_bar_width = results_bar.offsetWidth,
        result_options = results_bar.querySelectorAll('ul li'),
        options_width = result_options.length * 43;

    result_options.forEach((result_option) => {
      options_width += result_option.offsetWidth;
    });

    if(options_width > results_bar_width) {
      results_bar.classList.add('overflow');
    } else {
      results_bar.classList.remove('overflow');
    }
  }

  var character_counter = document.querySelector('.character-counter');
  if(character_counter) {
    var textarea_limit = 250,
        character_counter_textarea = character_counter.querySelector('textarea');

    if(character_counter_textarea.hasAttribute('data-limit')) {
      textarea_limit = character_counter_textarea.getAttribute('data-limit');
    }

    var counter = document.createElement('div');
    counter.classList.add('js-character-counter');
    counter.innerHTML = 'Character Count: <span>0</span>/' + textarea_limit;

    character_counter.appendChild(counter);

    var counter_length = counter.querySelector('span');

    character_counter_textarea.addEventListener('keyup', (e) => {
      var textarea_size = character_counter_textarea.value.length;

      if(textarea_size > textarea_limit) {
        e.preventDefault();
        character_counter_textarea.value = character_counter_textarea.value.substr(0, textarea_limit + 1);
        textarea_size = textarea_limit;
      }

      counter_length.innerText = textarea_size;
    });
  }

  var firm_profile_map_info = document.querySelector('.map-container .firm-details .close');
  if(firm_profile_map_info) {
    firm_profile_map_info.addEventListener('click', (e) => {
      e.preventDefault();
      document.querySelector('.map-container .firm-details').classList.add('hide');
    });
  }

  var attorney_card_closes = document.querySelectorAll('.attorney-card .close-card');
  if(attorney_card_closes) {
    attorney_card_closes.forEach((attorney_card_close) => {
      attorney_card_close.addEventListener('click', (e) => {
        e.preventDefault();
        attorney_card_close.parentNode.classList.remove('show');
      });
    });
  }

  var search_sort_toggle = document.querySelector('.sort-toggle');
  if(search_sort_toggle) {
    search_sort_toggle.addEventListener('change', () => {
      window.location = '/?sort=' + search_sort_toggle.querySelector('select').value;
    });
  }

  var mailto_triggers = document.querySelectorAll('.js-mailto');
  if(mailto_triggers) {
    mailto_triggers.forEach((mailto_trigger) => {
      var mailto_modal = document.getElementById('mailto-modal-container'),
          mailto_modal_close = mailto_modal.querySelector('.close'),
          mailto_modal_textarea = mailto_modal.querySelector('textarea');

      mailto_modal.addEventListener('keyup', (e) => {
        if(e.key.toLowerCase() === 'escape') {
          mailto_modal.classList.remove('show');
          mailto_modal_textarea.value = '';
        }
      });

      mailto_modal_close.addEventListener('click', (e) => {
        mailto_modal.classList.remove('show');
        mailto_modal_textarea.value = '';
      });

      mailto_trigger.addEventListener('click', (e) => {
        e.preventDefault();

        var email_text = mailto_trigger.querySelector('textarea').innerText;

        mailto_modal_textarea.value = email_text;

        mailto_modal.classList.add('show');

        mailto_modal_textarea.focus();
        mailto_modal_textarea.select();

        setTimeout(() => {
          mailto_modal_textarea.scrollTop = 0;
        }, 100);
      });
    });
  }

}());
